export default "__VITE_ASSET__DQ5l3Q0c__"